import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CategoryStore {

}

export enum CategoryStoreKeys {

}
